import { BillLineInstallmentNumberV2, BillLineItemV2Kind } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemInstallmentNumber =
  new MockFactory<BillLineInstallmentNumberV2>({
    kind: BillLineItemV2Kind.InstallmentNumber,
    metadata: {
      current_installment: 1,
      total_number_of_installments: 3,
    },
  })
